export const visitFormFields = [
  {
    name: 'assignedTo',
    label: 'Assigned to',
    type: 'select',
    items: [
      { value: 'user_1', label: 'User 1' },
      { value: 'user_2', label: 'User 2' },
      { value: 'user_3', label: 'User 3' },
    ],
    grid: {
      sm: 12,
      xs: 12,
    },
    rules: {
      required: 'This field is required.',
    },
  },

  {
    name: 'scheduledDateTime',
    label: 'Scheduled date and time',
    type: 'datetime',
    grid: {
      sm: 12,
      xs: 12,
    },
  },
];
